import useScrollReveal from "../hooks/useScrollReveal";

const exampleStats = [
  { value: "10", label: "Fans referred" },
  { value: "5%", label: "Your cut" },
  { value: "1 YEAR", label: "Duration" },
];

const ReferralExample = () => {
  const [ref, visible] = useScrollReveal(0.1);

  return (
    <section className="px-10 sm:px-4 pb-16 sm:pb-10 mx-auto w-full">
      <div
        ref={ref}
        className={`transition-all duration-700 ease-out ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className=" border border-[rgba(255,245,40,0.15)] rounded-xl p-6 sm:p-4 flex flex-col sm:flex-col gap-6"  style={{
  background: "linear-gradient(to bottom, #FFF52814 0%, #FF9A4B0F 100%)",
}}>
          {/* Top: label + text */}
          <div className="flex flex-col sm:flex-col gap-3 flex-1">
            <p className="text-[#FFF528] text-sm font-semibold tracking-widest uppercase font-League_Spartan">
              EXAMPLE
            </p>
            <div className="flex sm:flex-col gap-6 sm:gap-3 items-start sm:items-start justify-between">
              <div className="flex-1">
                <p className="text-white font-sans text-md sm:text-xs leading-relaxed">
                  You invite{" "}
                  <span className="text-[#FFF528] font-bold">10 fans</span> to
                  Vupop.
                </p>
                <p className="mt-2 text-[rgba(255,255,255,0.60)] font-sans text-sm sm:text-xs leading-relaxed max-w-lg">
                  If those users upload clips that generate revenue on the
                  platform, you'll automatically receive{" "}
                  <span className="text-white font-semibold">
                    5% of that revenue
                  </span>{" "}
                  for up to one year after they sign up.
                </p>
              </div>

              {/* Stats inline */}
              <div className="flex gap-6 sm:gap-4 items-end sm:items-start shrink-0 sm:mt-2">
                {exampleStats.map(({ value, label }, i) => (
                  <div key={i} className="flex flex-col items-center sm:items-start gap-0.5">
                    <span className="font-[Norwester]  text-white text-2xl sm:text-base">
                      {value}
                    </span>
                    <span className="text-[rgba(255,255,255,0.40)] text-[12px] sm:text-[10px] font-sans whitespace-nowrap">
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralExample;